<template>
  <div>
    <b-row>
      <b-col md="8">
        <Logo :onClick='onTitleClick' />
      </b-col>
      <b-col class="searchfield" md="4">
        <SearchField />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import SearchField from '@/components/SearchField.vue'

export default {
  name: 'custom-header',
  components: {
    Logo,
    SearchField
  },
  methods: {
    onTitleClick () {
      this.$router.push('/')
    }
  }
}
</script>

<style>
.searchfield {
  padding-left: 0px !important;
}

@media (max-width: 768px) {
  .searchfield {
    padding: 5px !important;
  }
}
</style>
